import { render, staticRenderFns } from "./FavoriteProjects.vue?vue&type=template&id=7f444cfe&scoped=true"
import script from "./FavoriteProjects.vue?vue&type=script&lang=js"
export * from "./FavoriteProjects.vue?vue&type=script&lang=js"
import style0 from "./FavoriteProjects.vue?vue&type=style&index=0&id=7f444cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f444cfe",
  null
  
)

export default component.exports